import { DeleteOutlined, UndoOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { type FC } from "react";

interface DeleteButtonProps {
	checkedItems: unknown[];
	viewingDeleted: boolean;
	onClick: () => void;
}

const DeleteButton: FC<DeleteButtonProps> = ({
	checkedItems,
	viewingDeleted,
	onClick,
}) => {
	if (viewingDeleted) {
		return (
			<Button
				onClick={onClick}
				type="text"
				icon={<UndoOutlined style={{ fontSize: "20px" }} />}
				disabled={checkedItems?.length === 0}
			>
				Undelete
			</Button>
		);
	}

	return (
		<Button
			onClick={onClick}
			type="text"
			danger
			icon={<DeleteOutlined style={{ fontSize: "20px" }} />}
			disabled={checkedItems?.length === 0}
		/>
	);
};

export { DeleteButton };
